/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Payin admin
 * Payin application
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { payinKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType, type BodyType } from '../../shared/api/kyMutator';
import {
    type AdminPayinTraderServiceCountTradersParams,
    type AdminPayinTraderServiceGetTraderParams,
    type AdminPayinTraderServiceGetUsersTraderParams,
    type AdminPayinTraderServiceListTradersParams,
    type GoogleRpcStatus,
    type PayinAdminTraderV1ActivateTraderRequest,
    type PayinAdminTraderV1ActivateTraderResponse,
    type PayinAdminTraderV1BlockTraderRequest,
    type PayinAdminTraderV1BlockTraderResponse,
    type PayinAdminTraderV1CountTradersResponse,
    type PayinAdminTraderV1GetTraderResponse,
    type PayinAdminTraderV1GetUsersTraderResponse,
    type PayinAdminTraderV1ListTradersResponse,
    type PayinAdminTraderV1UnblockTraderRequest,
    type PayinAdminTraderV1UnblockTraderResponse,
    type PayinAdminTraderV1UpdateTraderConfigRequest,
    type PayinAdminTraderV1UpdateTraderConfigResponse,
    type PayinAdminTraderV1UpdateTraderRequest,
    type PayinAdminTraderV1UpdateTraderResponse,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
    const result = { queryKey } as T & { queryKey: K };

    for (const key of Object.keys(query)) {
        // The explicit queryKey always wins, matching the previous
        // `{ ...query, queryKey }` spread where it was set last.
        if (key === 'queryKey') { continue; }

        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get: () => (query as Record<string, unknown>)[key],
        });
    }

    return result;
};

export const getAdminPayinTraderServiceGetTraderUrl = (params?: AdminPayinTraderServiceGetTraderParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/trader?${stringifiedParams}` : '/v1/trader';
};

export const adminPayinTraderServiceGetTrader = async (
    params?: AdminPayinTraderServiceGetTraderParams,
    options?: RequestInit,
): Promise<PayinAdminTraderV1GetTraderResponse> => {
    return payinKyMutator<PayinAdminTraderV1GetTraderResponse>(getAdminPayinTraderServiceGetTraderUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayinTraderServiceGetTraderQueryKey = (params?: AdminPayinTraderServiceGetTraderParams) => {
    return ['/v1/trader', ...(params ? [params] : [])] as const;
};

export const getAdminPayinTraderServiceGetTraderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceGetTraderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayinTraderServiceGetTraderQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>> = ({ signal }) =>
        adminPayinTraderServiceGetTrader(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinTraderServiceGetTraderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>
>;
export type AdminPayinTraderServiceGetTraderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinTraderServiceGetTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayinTraderServiceGetTraderParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceGetTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceGetTraderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceGetTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceGetTraderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinTraderServiceGetTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceGetTraderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceGetTrader>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinTraderServiceGetTraderQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinTraderServiceUpdateTraderUrl = () => {
    return '/v1/trader';
};

export const adminPayinTraderServiceUpdateTrader = async (
    payinAdminTraderV1UpdateTraderRequest: PayinAdminTraderV1UpdateTraderRequest,
    options?: RequestInit,
): Promise<PayinAdminTraderV1UpdateTraderResponse> => {
    return payinKyMutator<PayinAdminTraderV1UpdateTraderResponse>(getAdminPayinTraderServiceUpdateTraderUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payinAdminTraderV1UpdateTraderRequest),
    });
};

export const getAdminPayinTraderServiceUpdateTraderQueryKey = (
    payinAdminTraderV1UpdateTraderRequest?: BodyType<PayinAdminTraderV1UpdateTraderRequest>,
) => {
    return ['PATCH', '/v1/trader', payinAdminTraderV1UpdateTraderRequest] as const;
};

export const getAdminPayinTraderServiceUpdateTraderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UpdateTraderRequest: BodyType<PayinAdminTraderV1UpdateTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getAdminPayinTraderServiceUpdateTraderQueryKey(payinAdminTraderV1UpdateTraderRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>> = ({ signal }) =>
        adminPayinTraderServiceUpdateTrader(payinAdminTraderV1UpdateTraderRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinTraderServiceUpdateTraderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>
>;
export type AdminPayinTraderServiceUpdateTraderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinTraderServiceUpdateTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UpdateTraderRequest: BodyType<PayinAdminTraderV1UpdateTraderRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceUpdateTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UpdateTraderRequest: BodyType<PayinAdminTraderV1UpdateTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceUpdateTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UpdateTraderRequest: BodyType<PayinAdminTraderV1UpdateTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinTraderServiceUpdateTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UpdateTraderRequest: BodyType<PayinAdminTraderV1UpdateTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinTraderServiceUpdateTraderQueryOptions(
        payinAdminTraderV1UpdateTraderRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinTraderServiceActivateTraderUrl = () => {
    return '/v1/trader/activate';
};

export const adminPayinTraderServiceActivateTrader = async (
    payinAdminTraderV1ActivateTraderRequest: PayinAdminTraderV1ActivateTraderRequest,
    options?: RequestInit,
): Promise<PayinAdminTraderV1ActivateTraderResponse> => {
    return payinKyMutator<PayinAdminTraderV1ActivateTraderResponse>(getAdminPayinTraderServiceActivateTraderUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payinAdminTraderV1ActivateTraderRequest),
    });
};

export const getAdminPayinTraderServiceActivateTraderQueryKey = (
    payinAdminTraderV1ActivateTraderRequest?: BodyType<PayinAdminTraderV1ActivateTraderRequest>,
) => {
    return ['PATCH', '/v1/trader/activate', payinAdminTraderV1ActivateTraderRequest] as const;
};

export const getAdminPayinTraderServiceActivateTraderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1ActivateTraderRequest: BodyType<PayinAdminTraderV1ActivateTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayinTraderServiceActivateTraderQueryKey(payinAdminTraderV1ActivateTraderRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>> = ({ signal }) =>
        adminPayinTraderServiceActivateTrader(payinAdminTraderV1ActivateTraderRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinTraderServiceActivateTraderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>
>;
export type AdminPayinTraderServiceActivateTraderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinTraderServiceActivateTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1ActivateTraderRequest: BodyType<PayinAdminTraderV1ActivateTraderRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceActivateTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1ActivateTraderRequest: BodyType<PayinAdminTraderV1ActivateTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceActivateTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1ActivateTraderRequest: BodyType<PayinAdminTraderV1ActivateTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinTraderServiceActivateTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1ActivateTraderRequest: BodyType<PayinAdminTraderV1ActivateTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceActivateTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinTraderServiceActivateTraderQueryOptions(
        payinAdminTraderV1ActivateTraderRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinTraderServiceBlockTraderUrl = () => {
    return '/v1/trader/block';
};

export const adminPayinTraderServiceBlockTrader = async (
    payinAdminTraderV1BlockTraderRequest: PayinAdminTraderV1BlockTraderRequest,
    options?: RequestInit,
): Promise<PayinAdminTraderV1BlockTraderResponse> => {
    return payinKyMutator<PayinAdminTraderV1BlockTraderResponse>(getAdminPayinTraderServiceBlockTraderUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payinAdminTraderV1BlockTraderRequest),
    });
};

export const getAdminPayinTraderServiceBlockTraderQueryKey = (
    payinAdminTraderV1BlockTraderRequest?: BodyType<PayinAdminTraderV1BlockTraderRequest>,
) => {
    return ['PATCH', '/v1/trader/block', payinAdminTraderV1BlockTraderRequest] as const;
};

export const getAdminPayinTraderServiceBlockTraderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1BlockTraderRequest: BodyType<PayinAdminTraderV1BlockTraderRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ?? getAdminPayinTraderServiceBlockTraderQueryKey(payinAdminTraderV1BlockTraderRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>> = ({ signal }) =>
        adminPayinTraderServiceBlockTrader(payinAdminTraderV1BlockTraderRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinTraderServiceBlockTraderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>
>;
export type AdminPayinTraderServiceBlockTraderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinTraderServiceBlockTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1BlockTraderRequest: BodyType<PayinAdminTraderV1BlockTraderRequest>,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceBlockTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1BlockTraderRequest: BodyType<PayinAdminTraderV1BlockTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceBlockTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1BlockTraderRequest: BodyType<PayinAdminTraderV1BlockTraderRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinTraderServiceBlockTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1BlockTraderRequest: BodyType<PayinAdminTraderV1BlockTraderRequest>,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceBlockTrader>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinTraderServiceBlockTraderQueryOptions(
        payinAdminTraderV1BlockTraderRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinTraderServiceUpdateTraderConfigUrl = () => {
    return '/v1/trader/config';
};

export const adminPayinTraderServiceUpdateTraderConfig = async (
    payinAdminTraderV1UpdateTraderConfigRequest: PayinAdminTraderV1UpdateTraderConfigRequest,
    options?: RequestInit,
): Promise<PayinAdminTraderV1UpdateTraderConfigResponse> => {
    return payinKyMutator<PayinAdminTraderV1UpdateTraderConfigResponse>(
        getAdminPayinTraderServiceUpdateTraderConfigUrl(),
        {
            ...options,
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json', ...options?.headers },
            body: JSON.stringify(payinAdminTraderV1UpdateTraderConfigRequest),
        },
    );
};

export const getAdminPayinTraderServiceUpdateTraderConfigQueryKey = (
    payinAdminTraderV1UpdateTraderConfigRequest?: BodyType<PayinAdminTraderV1UpdateTraderConfigRequest>,
) => {
    return ['PATCH', '/v1/trader/config', payinAdminTraderV1UpdateTraderConfigRequest] as const;
};

export const getAdminPayinTraderServiceUpdateTraderConfigQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UpdateTraderConfigRequest: BodyType<PayinAdminTraderV1UpdateTraderConfigRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayinTraderServiceUpdateTraderConfigQueryKey(payinAdminTraderV1UpdateTraderConfigRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>> = ({
        signal,
    }) =>
        adminPayinTraderServiceUpdateTraderConfig(payinAdminTraderV1UpdateTraderConfigRequest, {
            signal,
            ...requestOptions,
        });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinTraderServiceUpdateTraderConfigQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>
>;
export type AdminPayinTraderServiceUpdateTraderConfigQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinTraderServiceUpdateTraderConfig<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UpdateTraderConfigRequest: BodyType<PayinAdminTraderV1UpdateTraderConfigRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceUpdateTraderConfig<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UpdateTraderConfigRequest: BodyType<PayinAdminTraderV1UpdateTraderConfigRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceUpdateTraderConfig<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UpdateTraderConfigRequest: BodyType<PayinAdminTraderV1UpdateTraderConfigRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinTraderServiceUpdateTraderConfig<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UpdateTraderConfigRequest: BodyType<PayinAdminTraderV1UpdateTraderConfigRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUpdateTraderConfig>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinTraderServiceUpdateTraderConfigQueryOptions(
        payinAdminTraderV1UpdateTraderConfigRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinTraderServiceCountTradersUrl = (params?: AdminPayinTraderServiceCountTradersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['filter.statuses'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/trader/count?${stringifiedParams}` : '/v1/trader/count';
};

export const adminPayinTraderServiceCountTraders = async (
    params?: AdminPayinTraderServiceCountTradersParams,
    options?: RequestInit,
): Promise<PayinAdminTraderV1CountTradersResponse> => {
    return payinKyMutator<PayinAdminTraderV1CountTradersResponse>(getAdminPayinTraderServiceCountTradersUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayinTraderServiceCountTradersQueryKey = (params?: AdminPayinTraderServiceCountTradersParams) => {
    return ['/v1/trader/count', ...(params ? [params] : [])] as const;
};

export const getAdminPayinTraderServiceCountTradersQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceCountTradersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayinTraderServiceCountTradersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>> = ({ signal }) =>
        adminPayinTraderServiceCountTraders(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinTraderServiceCountTradersQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>
>;
export type AdminPayinTraderServiceCountTradersQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinTraderServiceCountTraders<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayinTraderServiceCountTradersParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceCountTraders<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceCountTradersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceCountTraders<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceCountTradersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinTraderServiceCountTraders<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceCountTradersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceCountTraders>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinTraderServiceCountTradersQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinTraderServiceUnblockTraderUrl = () => {
    return '/v1/trader/unblock';
};

export const adminPayinTraderServiceUnblockTrader = async (
    payinAdminTraderV1UnblockTraderRequest: PayinAdminTraderV1UnblockTraderRequest,
    options?: RequestInit,
): Promise<PayinAdminTraderV1UnblockTraderResponse> => {
    return payinKyMutator<PayinAdminTraderV1UnblockTraderResponse>(getAdminPayinTraderServiceUnblockTraderUrl(), {
        ...options,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payinAdminTraderV1UnblockTraderRequest),
    });
};

export const getAdminPayinTraderServiceUnblockTraderQueryKey = (
    payinAdminTraderV1UnblockTraderRequest?: BodyType<PayinAdminTraderV1UnblockTraderRequest>,
) => {
    return ['PATCH', '/v1/trader/unblock', payinAdminTraderV1UnblockTraderRequest] as const;
};

export const getAdminPayinTraderServiceUnblockTraderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UnblockTraderRequest: BodyType<PayinAdminTraderV1UnblockTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey =
        queryOptions?.queryKey ??
        getAdminPayinTraderServiceUnblockTraderQueryKey(payinAdminTraderV1UnblockTraderRequest);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>> = ({ signal }) =>
        adminPayinTraderServiceUnblockTrader(payinAdminTraderV1UnblockTraderRequest, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinTraderServiceUnblockTraderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>
>;
export type AdminPayinTraderServiceUnblockTraderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinTraderServiceUnblockTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UnblockTraderRequest: BodyType<PayinAdminTraderV1UnblockTraderRequest>,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceUnblockTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UnblockTraderRequest: BodyType<PayinAdminTraderV1UnblockTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceUnblockTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UnblockTraderRequest: BodyType<PayinAdminTraderV1UnblockTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useAdminPayinTraderServiceUnblockTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    payinAdminTraderV1UnblockTraderRequest: BodyType<PayinAdminTraderV1UnblockTraderRequest>,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceUnblockTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinTraderServiceUnblockTraderQueryOptions(
        payinAdminTraderV1UnblockTraderRequest,
        options,
    );

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinTraderServiceListTradersUrl = (params?: AdminPayinTraderServiceListTradersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = ['filter.statuses'];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : String(v));
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/traders?${stringifiedParams}` : '/v1/traders';
};

/**
 * @summary List payin traders.
 */
export const adminPayinTraderServiceListTraders = async (
    params?: AdminPayinTraderServiceListTradersParams,
    options?: RequestInit,
): Promise<PayinAdminTraderV1ListTradersResponse> => {
    return payinKyMutator<PayinAdminTraderV1ListTradersResponse>(getAdminPayinTraderServiceListTradersUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getAdminPayinTraderServiceListTradersQueryKey = (params?: AdminPayinTraderServiceListTradersParams) => {
    return ['/v1/traders', ...(params ? [params] : [])] as const;
};

export const getAdminPayinTraderServiceListTradersQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceListTradersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayinTraderServiceListTradersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>> = ({ signal }) =>
        adminPayinTraderServiceListTraders(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinTraderServiceListTradersQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>
>;
export type AdminPayinTraderServiceListTradersQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinTraderServiceListTraders<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayinTraderServiceListTradersParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceListTraders<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceListTradersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceListTraders<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceListTradersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List payin traders.
 */

export function useAdminPayinTraderServiceListTraders<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceListTradersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceListTraders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinTraderServiceListTradersQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}

export const getAdminPayinTraderServiceGetUsersTraderUrl = (params?: AdminPayinTraderServiceGetUsersTraderParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : String(value));
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/users/trader?${stringifiedParams}` : '/v1/users/trader';
};

/**
 * @summary Get trader by auth app user
 */
export const adminPayinTraderServiceGetUsersTrader = async (
    params?: AdminPayinTraderServiceGetUsersTraderParams,
    options?: RequestInit,
): Promise<PayinAdminTraderV1GetUsersTraderResponse> => {
    return payinKyMutator<PayinAdminTraderV1GetUsersTraderResponse>(
        getAdminPayinTraderServiceGetUsersTraderUrl(params),
        {
            ...options,
            method: 'GET',
        },
    );
};

export const getAdminPayinTraderServiceGetUsersTraderQueryKey = (
    params?: AdminPayinTraderServiceGetUsersTraderParams,
) => {
    return ['/v1/users/trader', ...(params ? [params] : [])] as const;
};

export const getAdminPayinTraderServiceGetUsersTraderQueryOptions = <
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceGetUsersTraderParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getAdminPayinTraderServiceGetUsersTraderQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>> = ({ signal }) =>
        adminPayinTraderServiceGetUsersTrader(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPayinTraderServiceGetUsersTraderQueryResult = NonNullable<
    Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>
>;
export type AdminPayinTraderServiceGetUsersTraderQueryError = ErrorType<GoogleRpcStatus>;

export function useAdminPayinTraderServiceGetUsersTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | AdminPayinTraderServiceGetUsersTraderParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceGetUsersTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceGetUsersTraderParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>,
                    TError,
                    Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPayinTraderServiceGetUsersTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceGetUsersTraderParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get trader by auth app user
 */

export function useAdminPayinTraderServiceGetUsersTrader<
    TData = Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: AdminPayinTraderServiceGetUsersTraderParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof adminPayinTraderServiceGetUsersTrader>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getAdminPayinTraderServiceGetUsersTraderQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return withQueryKey(query, queryOptions.queryKey);
}
